import { css } from "@emotion/react"

const COMPANY_TAG_COLOR = "#C8F2FA"

export const CompanyTag = () => (
    <div
        css={css`
            width: max-content;
            padding: 4px 8px;
            text-align: center;
            background-color: ${COMPANY_TAG_COLOR};
            border-radius: 4px;
        `}
    >
        業者
    </div>
)
